import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

const STEPS = [
  { n: "01", t: "Apply free", d: "Create your seller account and tell us about your work. We do not charge a sign-up fee." },
  { n: "02", t: "Submit a product", d: "Upload images, descriptions, and pricing. For digital goods, upload the file directly." },
  { n: "03", t: "We review", d: "Our admin reviews each submission. We aim to respond within 48 hours." },
  { n: "04", t: "Goes live, you get paid", d: "Approved products go on the storefront. We keep 30%, you receive 70% via PayPal, mobile money, or bank." },
];

export default function SellLanding() {
  return (
    <Layout>
      <section className="border-b-2 border-[#1F3D2A]">
        <div className="max-w-[1400px] mx-auto px-6 py-20 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.3em] text-[#C77E3C]">/ For artisans</div>
            <h1 className="heading text-5xl sm:text-7xl font-black uppercase tracking-tighter mt-4">Sell your work on Jubasmash.</h1>
            <p className="mt-6 text-lg text-[#555] max-w-xl leading-relaxed">A curated home for independent makers. Books, songs, ceramics, prints — anything you make, we'll help you sell it.</p>
            <div className="mt-8 flex gap-3 flex-wrap">
              <Link to="/signup?role=seller" data-testid="apply-seller-btn" className="btn-primary">Apply to sell →</Link>
              <Link to="/sell/stream" data-testid="sell-stream-btn" className="btn-ghost">Upload a stream 🎧</Link>
              <Link to="/login" className="btn-ghost">I already have an account</Link>
            </div>
          </div>
          <div className="lg:col-span-5 brut-border bg-[#C77E3C] text-white p-6 brut-shadow">
            <div className="mono text-[10px] uppercase tracking-[0.3em]">/ Commission</div>
            <div className="heading text-6xl font-black uppercase mt-2">30%</div>
            <p className="mt-3 text-sm leading-relaxed">Of every gross sale stays with Jubasmash. The remaining 70% is yours, paid out via PayPal, mobile money, or bank transfer.</p>
            <ul className="mt-6 space-y-2 text-sm">
              <li>★ No listing fees</li>
              <li>★ No monthly minimum</li>
              <li>★ You keep full ownership of your work</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 py-20">
        <h2 className="heading text-3xl md:text-5xl font-black uppercase tracking-tight">How it works</h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-4 gap-0 brut-border bg-white">
          {STEPS.map((s, i) => (
            <div key={s.n} className={`p-6 ${i > 0 ? "md:border-l-2 border-t-2 md:border-t-0 border-[#1F3D2A]" : ""}`}>
              <div className="mono text-xs text-[#C77E3C] tracking-[0.3em]">{s.n}</div>
              <h3 className="heading text-xl font-bold uppercase mt-2">{s.t}</h3>
              <p className="text-sm text-[#555] mt-2 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
